import { Autocomplete, TextField } from '@mui/material'
import React, { useState } from 'react'
import useIdentities from '../../hooks/api/useIdentities'
import HalfContainer from './HalfContainer'

const AccountOwnerSelect = ({
  disabled,
  primaryAccountOwner,
  setPrimaryAccountOwner,
  secondaryAccountOwners,
  setSecondaryAccountOwners,
  secondaryOnly = false,
  secondaryOwnersTextOverride,
}) => {
  const [queryString, setQueryString] = useState('')

  const { identities } = useIdentities(queryString, {
    limit: 10,
    is_claimed: true,
  })

  return (
    <>
      {!secondaryOnly && (
        <HalfContainer>
          <Autocomplete
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={primaryAccountOwner}
            onChange={(_, value) => {
              setPrimaryAccountOwner(value)
            }}
            fullWidth
            disabled={disabled}
            options={identities}
            getOptionLabel={(o) => `${o.firstName} ${o.lastName}`}
            renderInput={(params) => (
              <TextField
                {...params}
                margin={'dense'}
                fullWidth
                disabled={disabled}
                label='Primary Account Owner'
                onChange={(e) => setQueryString(e.target.value)}
              ></TextField>
            )}
          ></Autocomplete>
        </HalfContainer>
      )}
      <HalfContainer>
        <Autocomplete
          multiple
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={secondaryAccountOwners}
          onChange={(_, value) => {
            setSecondaryAccountOwners(value)
          }}
          fullWidth
          disabled={disabled}
          options={identities}
          getOptionLabel={(o) => `${o.firstName} ${o.lastName}`}
          renderInput={(params) => (
            <TextField
              {...params}
              margin={'dense'}
              fullWidth
              disabled={disabled}
              label={
                secondaryOwnersTextOverride
                  ? secondaryOwnersTextOverride
                  : 'Secondary Account Owners'
              }
              onChange={(e) => setQueryString(e.target.value)}
            ></TextField>
          )}
        ></Autocomplete>
      </HalfContainer>
    </>
  )
}

export default AccountOwnerSelect
